"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section ref={ref} className="relative flex min-h-screen items-center justify-center overflow-hidden bg-dark-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1497613/img/alabama_white_sand_beach_coastline.png)",
      transform: isVisible ? "translateY(0)" : "translateY(20px)",
      transition: "transform 1200ms cubic-bezier(0.22, 1, 0.36, 1)"
    }} />

      {}
      <div className="absolute inset-0 bg-primary/60 backdrop-blur-sm" />

      {}
      <div className={`relative z-10 flex max-w-4xl flex-col items-center gap-6 px-6 text-center transition-all duration-[150ms] ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
        {}
        <h1 className="font-display text-5xl font-bold leading-tight text-foreground-dark md:text-6xl lg:text-7xl">
          World-Class Technology. Hometown Service.
        </h1>

        {}
        <p className="max-w-2xl text-lg leading-relaxed text-foreground-dark/90 md:text-xl">
          Coastal AI & Technology, LLC brings over 50 years of combined expertise in technology strategies that build your business. We provide businesses of all sizes with the elite solutions and strategic leadership usually reserved for global enterprises.
        </p>

        {}
        <Button asChild size="lg" className="group mt-4 bg-accent text-foreground-accent shadow-medium transition-all duration-[80ms] ease-in-out hover:scale-[1.02] hover:bg-accent-hover hover:shadow-strong focus-visible:ring-accent">
          <Link to="#about-us">
            <span>Discover CAIT</span>
            <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
          </Link>
        </Button>
      </div>
    </section>;
}